import { createActionGroup, emptyProps } from '@ngrx/store';

export const HomePageActions = createActionGroup({
  source: 'Home Page',
  events: {
    Enter: emptyProps(),
  },
});
